import type { FC } from 'react';

import { SvgIcon, type SvgIconProps } from '../SvgIcon';

const LH = 28;
const LW = 1.8;

const LY = -LH / 2;
const LX = -LW / 2;

export const TheoIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon viewBox="-16 -16 32 32" {...props}>
    <defs>
      <mask id="theo-mask" maskUnits="userSpaceOnUse" x="-16" y="-16" width="32" height="32">
        <rect x={LX} y={LY} width={LW} height={LH} fill="white" rx="0.25" transform="rotate(0)" />
        <rect x={LX} y={LY} width={LW} height={LH} fill="white" rx="0.25" transform="rotate(30)" />
        <rect x={LX} y={LY} width={LW} height={LH} fill="white" rx="0.25" transform="rotate(60)" />
        <rect x={LX} y={LY} width={LW} height={LH} fill="white" rx="0.25" transform="rotate(90)" />
        <rect x={LX} y={LY} width={LW} height={LH} fill="white" rx="0.25" transform="rotate(120)" />
        <rect x={LX} y={LY} width={LW} height={LH} fill="white" rx="0.25" transform="rotate(150)" />
        <circle cx="0" cy="0" r="2" fill="black" />
      </mask>
    </defs>
    <circle cx="0" cy="0" r={LH / 2} fill="currentColor" mask="url(#theo-mask)" />
  </SvgIcon>
);
